<template>
  <div class="searchBoxContainer" v-click-outside="clickOutside">
    <!-- filterInput -->
    <!-- @blur="blurInput()" -->
    <input
      @input="handleInput($event)"
      :value="text"
      type="text"
      :placeholder="placeholder"
      :class="[classes, found ? 'colorDarkGrey' : 'colorBlue']"
      ref="input"
      @focus="handleFocus()"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    >

    <!-- @mousedown.self="clickDropdown($event)" -->
    <div ref="dropDownContainer" v-if="dropDownOpen" class="dropDown">
      <div
        v-for="(option,index) of visibleOptions"
        :key="index"
        :ref="'option'+index"
        @click.stop="handleDropDownOptionClick(option)"
        @mouseover="activeIndex = index"
        :class="['dropDownOption', index === activeIndex ? 'backgroundBlue' : '']"
      >{{getDisplay(option)}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBox",
  props: ["value", "placeholder", "classes", "options", "display", "divider"],
  data: function() {
    return {
      dropDownOpen: false,
      text: null,
      activeIndex: null,
      visibleOptions: null,
      found: !!this.value,
      focusEventStarted: false
    };
  },
  mounted() {
    if (this.value) this.text = this.getDisplay(this.value);
    this.checkVisibleOptions();
  },
  watch: {
    value: function(newVal, oldVal) {
      // watch for changes => map changes coords
      if (!newVal) return;
      this.text = this.getDisplay(newVal);
    }
  },
  methods: {
    clickOutside() {
      if (this.focusEventStarted) {
        return;
      }
      this.dropDownOpen = false;
    },
    focus() {
      this.focusEventStarted = true;
      setTimeout(() => {
        this.focusEventStarted = false;
      }, 0);
      this.$refs.input.focus();
    },
    getDisplay(anschlussstelle) {
      let string = "";
      for (const index in this.display) {
        string += anschlussstelle[this.display[index]] + this.divider;
      }
      return string.substring(0, string.length - this.divider.length);
    },
    onArrowDown() {
      if (!this.activeIndex && this.activeIndex !== 0) {
        this.activeIndex = 0;
      } else {
        if (this.activeIndex === this.visibleOptions.length - 1) {
          this.activeIndex = 0;
        } else this.activeIndex++;
      }
      this.scrollToActiveIndex();
    },
    onArrowUp() {
      if (!this.activeIndex && this.activeIndex !== 0) {
        this.activeIndex = 0;
      } else {
        if (this.activeIndex === 0) {
          this.activeIndex = this.visibleOptions.length - 1;
        } else this.activeIndex--;
      }
      this.scrollToActiveIndex();
    },
    onEnter() {
      if (!this.activeIndex) this.activeIndex = 0;
      const value = this.visibleOptions[this.activeIndex];
      this.blurInput(value, true);
    },
    handleDropDownOptionClick(option) {
      this.setValue(option);
      this.dropDownOpen = false;
    },

    // Scroll wenn sich der aktive Index ändert => arrow keys
    scrollToActiveIndex() {
      if (this.visibleOptions.length <= 5) return;
      const el = this.$refs["option" + this.activeIndex];
      const container = this.$refs.dropDownContainer;
      container.scrollTo(0, el[0].offsetTop - 29 - 29);
    },

    // Verlieren des Focuses
    blurInput(value) {
      // Wenn kein Wert ausgewählt wurde der letzte vom mouseover//arrowkeys sonst der erste aus der Liste
      this.setValue(value);
      this.dropDownOpen = false;
    },

    checkFilter(option) {
      const displaytext = this.getDisplay(option);
      if (!this.text) return true;
      if (!this.text.trim()) return true;
      if (
        displaytext.toUpperCase().indexOf(this.text.trim().toUpperCase()) > -1
      ) {
        return true;
      } else return false;
    },

    handleInput(e) {
      this.dropDownOpen = true;
      const value = e.target.value;
      this.$emit("typing");
      this.text = value;
      this.found = false;
      this.checkVisibleOptions();
    },
    checkVisibleOptions() {
      this.visibleOptions = [];
      for (const option of this.options) {
        if (this.checkFilter(option)) {
          this.visibleOptions.push(option);
        }
      }
    },
    handleFocus() {
      this.dropDownOpen = true;
      this.checkVisibleOptions();
    },

    setValue(value) {
      this.found = true;
      this.text = this.getDisplay(value);
      this.$emit("input", value);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.searchBoxContainer {
  position: relative;
}
input {
  border: none;
  width: 100%;
  font-family: "Droid Sans", sans-serif;
  font-size: 16px;
  outline: none;
}

.dropDown {
  width: 100%;
  height: fit-content;
  min-height: 31px;
  max-height: 150px;
  position: absolute;
  border: 1px solid #c3c3c3;
  border-radius: 5px;
  z-index: 1;
  background-color: #fafafa;
  overflow-y: auto;
}

.dropDownOption {
  padding: 2.5px 5px;
  text-align: left;
}
.dropDownOption:hover {
  background-color: #64b5f6;
}
</style>
